import api from '../../services/api';

/*
 * The operator's pickup points: the shops where a courier leaves a parcel for
 * the end customer to collect. Owned by the admin; a seller never writes here.
 */

export const getPickupPointsRequest = async () => {
  return await api.get('warehouses/pickup_points/');
};

export const createPickupPointRequest = async (payload) => {
  return await api.post('warehouses/pickup_points/', payload);
};

export const updatePickupPointRequest = async (pickupPointId, payload) => {
  return await api.patch(`warehouses/pickup_points/${pickupPointId}/`, payload);
};

export const deletePickupPointRequest = async (pickupPointId) => {
  return await api.delete(`warehouses/pickup_points/${pickupPointId}/`);
};

/*
 * A shipment and its pickup point. The backend clones the point's address onto
 * the shipment and keeps the customer's original one, so the order comes back
 * whole and the detail only has to redraw it.
 */

export const redirectToPickupPointRequest = async (deliveryId, pickupPointId) => {
  return await api.post(`deliveries/${deliveryId}/pickup_point/`, { pickup_point_id: pickupPointId });
};

export const revertPickupPointRequest = async (deliveryId) => {
  return await api.delete(`deliveries/${deliveryId}/pickup_point/`);
};

export const handOverAtPickupPointRequest = async (deliveryId, receivedBy) => {
  return await api.post(`deliveries/${deliveryId}/pickup_point/handover/`, { received_by: receivedBy });
};
